<div *ngIf="isVisible" class="fixed inset-0 z-[10000] overflow-y-auto" aria-labelledby="error-modal-title"
  role="alertdialog" aria-modal="true">
  <div class="fixed inset-0 bg-slate-950/65" (click)="onBackdropClick()"></div>

  <div class="flex min-h-full items-end justify-center px-3 pb-[calc(1rem+env(safe-area-inset-bottom,0px))] pt-[calc(1rem+env(safe-area-inset-top,0px))] sm:items-center sm:p-6">
    <section class="relative w-full max-w-md overflow-hidden rounded-lg border border-app-accent-border-soft bg-app-surface shadow-app-raised">
      <div class="p-5 sm:p-6">
        <div class="flex items-start gap-3">
          <span class="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-lg bg-app-danger-soft text-app-danger" aria-hidden="true">
            <i class="bi bi-exclamation-octagon-fill app-icon text-xl"></i>
          </span>
          <div class="min-w-0 flex-1">
            <h3 id="error-modal-title" class="app-section-title text-app-ink">{{ errorTitle }}</h3>
            <p class="mt-2 whitespace-normal break-words leading-relaxed text-slate-600">{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <footer class="grid grid-cols-1 gap-2 border-t border-app-highlight-line bg-app-highlight-soft p-4">
        <button *ngIf="showBackButton" type="button" class="app-button-primary w-full" (click)="goBack()">
          <i class="bi bi-arrow-left app-icon" aria-hidden="true"></i>返回上一頁
        </button>
        <button *ngIf="!showBackButton" type="button" class="app-button-secondary w-full" (click)="close()">
          關閉
        </button>
      </footer>
    </section>
  </div>
</div>
